import { Link, Outlet } from 'react-router-dom';
import { Flame } from 'lucide-react';
import { Toaster } from '@/components/ui/sonner';

export function AuthShell() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 px-4 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-6 flex items-center justify-center gap-2">
          <Flame className="h-6 w-6 text-primary" />
          <span className="text-lg font-semibold tracking-tight">Wildfire Reporting</span>
        </Link>
        <Outlet />
      </div>
      <Toaster />
    </div>
  );
}

export default AuthShell;
